import React from "react";
import TextField from "@material-ui/core/TextField";
import { Typography } from "@material-ui/core";

export const numberRenderer = (
    value,
    name,
    fieldUpdateHandler,
    isError,
    mutable,
    editable,
) => {
    if (!value && typeof fieldUpdateHandler === "function" && mutable) {
        // creating data
        return (
            <TextField
                value={value || ""}
                type="number"
                onChange={(e) => fieldUpdateHandler(name, e.target.value)}
                error={!!isError}
                helperText={isError}
            />
        );
    } else if (
        value &&
        typeof fieldUpdateHandler === "function" &&
        editable !== false &&
        mutable
    ) {
        // updatig data
        return (
            <TextField
                value={value || ""}
                type="number"
                onChange={(e) => fieldUpdateHandler(name, e.target.value)}
                error={!!isError}
                helperText={isError}
            />
        );
    } else if (value && editable === false) {
        // view data when editable === false
        return <Typography children={value} />;
    } else if (value && !mutable) {
        // view data without editable parameter
        return <Typography children={value} />;
    } else {
        // to prevent crashes
        return [];
    }
};
